module.exports = __webpack_public_path__ + "img/20210218.85d6e1ab.gif";